import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf, DecimalPipe } from '@angular/common';

/**
 * Confirmation modal shown before starting a search-report export.
 *
 * It is intentionally dumb: it renders the confirmation copy based on how many
 * reports are selected and emits `confirmed` / `cancelled`. The parent
 * (ReportsComponent) owns the actual export dispatch and decides when to close.
 */
@Component({
  selector: 'app-report-export-confirm-modal',
  standalone: true,
  imports: [NgIf, DecimalPipe],
  templateUrl: './report-export-confirm-modal.component.html',
  styleUrl: './report-export-confirm-modal.component.scss'
})
export class ReportExportConfirmModalComponent {
  /** Whether the modal is rendered. */
  @Input() isVisible = false;

  /** Number of explicitly selected reports. 0 = export everything matching filters. */
  @Input() selectedCount = 0;

  /** Mirrors the export-in-flight state so the confirm button shows a spinner. */
  @Input() exporting = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    if (this.exporting) {
      return;
    }
    this.confirmed.emit();
  }

  onCancel(): void {
    if (this.exporting) {
      return;
    }
    this.cancelled.emit();
  }
}
